import { createPathWithAllFilters } from "@modules/azm/api.ts"
import { setAZMFilterPathLocationToSessionStorage } from "@modules/global/filter-path/filter-path-handler.ts"
import { isPC } from "@modules/util/device"
import { registerGlobalEventListener } from "@modules/util/events.ts"
import { createNewPathForLocationSlug } from "@modules/util/url"
export function updateLocationLinks(seoUrl: string) {
    const locationLinks = document.querySelectorAll<HTMLAnchorElement>("[data-location-slug]")
    for (const locationLink of locationLinks) {
        const citySlug = locationLink.getAttribute("data-location-slug") || ""
        locationLink.href = createNewPathForLocationSlug(seoUrl, citySlug, true)
    }
    updateAllRegionsLink(seoUrl)
    if (isPC()) {
        updateCityAdressesLinksPc(seoUrl)
    }

    setAZMFilterPathLocationToSessionStorage(createPathWithAllFilters(SiteInfo.controller))
}

function updateCityAdressesLinksPc(seoUrl: string) {
    const addressLinks = document.querySelectorAll<HTMLAnchorElement>(".adressenwahl a[data-eaid]")
    for (const addressLink of addressLinks) {
        const addressId = addressLink.getAttribute("data-eaid") || ""
        const url = new URL(seoUrl)
        if (addressId) {
            url.searchParams.set("adresse", addressId)
        } else {
            url.searchParams.delete("adresse")
        }
        addressLink.href = url.href
    }
}

function updateAllRegionsLink(seoUrl: string) {
    const allRegionsLink = document.getElementById("all-regions-link")
    if (allRegionsLink instanceof HTMLAnchorElement) {
        allRegionsLink.href = createNewPathForLocationSlug(seoUrl, "", true)
    }
}
registerGlobalEventListener("azm.filter-api.after-fetch", (event) => {
    updateLocationLinks(event.detail.seoUrl)
})

updateLocationLinks(window.location.href)
